import * as Yup from 'yup'


export const validationSchemasCierre = (action) => {
    let validation = {};

    validation.confirmaCierre = Yup.string().required('Este campo es obligatorio.');
    validation.comentarioRespuesta = Yup.string().required('Este campo es obligatorio.');
    if (action === "rechcierre") validation.motivoRechazo = Yup.string().required('Este campo es obligatorio.');

    return Yup.object().shape(validation);
}

export const validationSchemasDestinatario = () => {
    let validation = {};

    validation.idTipoDestinatario = Yup.string().required('Este campo es obligatorio.');
    validation.idClasificaDestino = Yup.string().required('Este campo es obligatorio.');
    validation.nombreDestinatario = Yup.string().required('Este campo es obligatorio.');
    validation.emailDestinatario = Yup.string().required('Este campo es obligatorio.').email('Email inválido.');

    return Yup.object().shape(validation);
}